import { SearchResultPipe } from './pipes/search-result';
import { FileSizePipe } from './pipes/file-size';
import { StandardLevelPipe } from './pipes/standard-level';
import { RemoveAltPipe } from './pipes/remove-alt';
import { ErrorAltPipe } from './pipes/error-alt';
import { BuildStatusPipe } from './pipes/build-status';
import { HighlightTermPipe } from './pipes/highlight-term';
import { EncodeHTMLPipe } from './pipes/html-encoder';
import { JobRolePipe } from './pipes/workload/job-role';
import { SlaBoundariesPipe } from './pipes/workload/sla-boundaries';
import { FormActionPipe } from './pipes/workload/form-actions';
import { LearningAimSizePipe } from './pipes/workload/learning-aim-size';
import { AmendTypePipe } from './pipes/workload/amend-type';
import { ReportTypePipe } from './pipes/workload/report-type';
export var STANDARD_PIPES = [
    SearchResultPipe,
    FileSizePipe,
    StandardLevelPipe,
    RemoveAltPipe,
    ErrorAltPipe,
    BuildStatusPipe,
    HighlightTermPipe,
    EncodeHTMLPipe
];
export var WORKLOAD_PIPES = [
    JobRolePipe,
    SlaBoundariesPipe,
    FormActionPipe,
    LearningAimSizePipe,
    AmendTypePipe,
    ReportTypePipe
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLnNoYXJlZC5waXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFwcC5zaGFyZWQucGlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sdUJBQXVCLENBQUM7QUFDekQsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ2pELE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLHdCQUF3QixDQUFDO0FBQzNELE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQztBQUNuRCxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFDakQsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBQ3ZELE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLHdCQUF3QixDQUFDO0FBQzNELE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUN0RCxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFDeEQsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0saUNBQWlDLENBQUM7QUFDcEUsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBQy9ELE9BQU8sRUFBRSxtQkFBbUIsRUFBRSxNQUFNLG9DQUFvQyxDQUFDO0FBQ3pFLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSw2QkFBNkIsQ0FBQztBQUM1RCxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFFOUQsTUFBTSxDQUFDLElBQU0sY0FBYyxHQUFHO0lBQzFCLGdCQUFnQjtJQUNoQixZQUFZO0lBQ1osaUJBQWlCO0lBQ2pCLGFBQWE7SUFDYixZQUFZO0lBQ1osZUFBZTtJQUNmLGlCQUFpQjtJQUNqQixjQUFjO0NBQ2pCLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxjQUFjLEdBQUc7SUFDMUIsV0FBVztJQUNYLGlCQUFpQjtJQUNqQixjQUFjO0lBQ2QsbUJBQW1CO0lBQ25CLGFBQWE7SUFDYixjQUFjO0NBQ2pCLENBQUMifQ==